import { cn } from "@/lib/utils";
import { STATUS_LABEL } from "@/lib/types";

const STYLES: Record<string, string> = {
  draft: "bg-gray-100 text-gray-700 ring-gray-200",
  internal_review: "bg-amber-50 text-amber-700 ring-amber-200",
  approved: "bg-emerald-50 text-emerald-700 ring-emerald-200",
  sent: "bg-blue-50 text-blue-700 ring-blue-200",
  viewed: "bg-indigo-50 text-indigo-700 ring-indigo-200",
  accepted: "bg-green-600 text-white ring-green-600",
  rejected: "bg-red-50 text-red-700 ring-red-200",
  revision_requested: "bg-orange-50 text-orange-700 ring-orange-200",
};

export const StatusBadge = ({ status, className }: { status: string; className?: string }) => (
  <span data-testid={`status-badge-${status}`} className={cn("inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset", STYLES[status] || STYLES.draft, className)}>
    {STATUS_LABEL[status] || status}
  </span>
);
